import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class BuyFeatureButtonEnableUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('Game.command.buyFeature.enable');
        this.onExecuted?.();
    }

    getName(): string {
        return 'BuyFeatureButtonEnableUIAct';
    }
}